import React from 'react'
import { baseUrl } from '../../common/constants.js'
import SocialShare from '../../components/SocialShare/SocialShare.jsx'

const BlogLinkShare = () => {
  const blogname = window.__initial_data__.user.blogname
  const url = `${baseUrl}/blog/${blogname}`

  return <SocialShare url={url} copiedLabel="sponsor_link_copied" clickToCopyLabel="sponsor_link_click_to_copy" />
}

export default BlogLinkShare
